import loadable from '@loadable/component';

const FormattedDate = loadable(
    async () =>
        import(
            /* webpackChunkName: "formatteddate" */ './InternalFormattedDate'
        )
);

export {FormattedDate};
